import { SignupSource, UserIntent } from "@brookbush/database";

import z from "zod";

export enum OnboardingChecklist {
	BECOME_A_MEMBER = "BECOME_A_MEMBER",
	ADD_PHONE_NUMBER = "ADD_PHONE_NUMBER",
	START_FIRST_COURSE = "START_FIRST_COURSE",
	REFER_A_FRIEND = "REFER_A_FRIEND",
	GENERATE_FIRST_PROGRAM = "GENERATE_FIRST_PROGRAM",
}

export interface OnboardingChecklistResponse {
	items: OnboardingChecklist[];
	isDismissed: boolean;
}

export const ceuGoalInputSchema = z.object({
	accreditationId: z.string().min(1),
	targetCredits: z.number().positive().optional(),
	renewalDate: z.string().datetime().nullish(),
});

export type CeuGoalInput = z.infer<typeof ceuGoalInputSchema>;

export const userOnboardingSchema = z.object({
	selectedCertificationId: z.string().optional().nullable(),

	primaryProfessionId: z.string().optional().nullable(),

	interests: z.array(z.string()).max(5).optional(),

	secondaryProfessionId: z.string().optional().nullable(),
	cataMemberNumber: z.string().optional().nullable(),

	ceuGoals: z.array(ceuGoalInputSchema).optional(),
	phoneNumber: z
		.string()
		.regex(/^\+[1-9]\d{1,14}$/, "Invalid phone number format")
		.optional()
		.nullable(),
	isOnboardingCompleted: z.boolean().optional(),
});

export type UserOnboarding = z.infer<typeof userOnboardingSchema>;

export interface UserOnboardingResponse {
	primaryProfessionId: string | null;
	secondaryProfessionId: string | null;
	selectedCertificationId: string | null;
	interests: string[];
	cataMemberNumber: string | null;
	smsPhoneNumber: string | null;
	isOnboardingCompleted: boolean;
}

export const userIntentToPrompt: Record<UserIntent, string> = {
	[UserIntent.EARN_CERTIFICATION]: "CPT, HMS or IMT Certification",
	[UserIntent.CONTINUING_EDUCATION_CREDITS]:
		"Continuing Education Credits (CECs)",
	[UserIntent.SKILL_DEVELOPMENT]: "Improve Practical Skills",
	[UserIntent.EXPLORING_PLATFORM]: "Exploring The Platform",
	[UserIntent.EMPLOYER_SPONSORED]: "Sponsored By Employer",
	[UserIntent.SCHOOL_SPONSORED]: "Referred by School",
	[UserIntent.OTHER]: "Some Other Reason",
};

export const signupSourceToPrompt: Record<SignupSource, string> = {
	[SignupSource.WORD_OF_MOUTH]: "Someone I know",
	[SignupSource.SEARCH_ENGINE]: "Search Engine (i.e. Google)",
	[SignupSource.FACEBOOK]: "Facebook",
	[SignupSource.INSTAGRAM]: "Instagram",
	[SignupSource.TWITTER_X]: "Twitter/X",
	[SignupSource.LINKEDIN]: "LinkedIn",
	[SignupSource.REDDIT]: "Reddit",
	[SignupSource.EMAIL_CAMPAIGN]: "Email",
	[SignupSource.YOUTUBE_VIDEO]: "YouTube Video",
	[SignupSource.PODCAST]: "Podcast",
	[SignupSource.PARTNERSHIP]: "Partnership",
	[SignupSource.OTHER]: "Other",
};
